import React, { useEffect } from "react";
import CodeChampsTemplate from "../../Templetes/CodeChamps/CodeChamps.template";

const CodeChampsPage = () => {
  useEffect(() => {
    document.title = "Code Challenge - CodeChamps Tracks";
  }, []);
  return <CodeChampsTemplate />;
};

export default CodeChampsPage;

